import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Flash = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="flash icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.4789 3.71041L21.5184 12.2528L18.2952 16.2086L22.9885 20.9019L30.1679 4.74822C30.6419 3.68168 29.2161 2.80561 28.4789 3.71041ZM11.1569 24.9693L14.2461 21.1779L19.6691 26.6009H11.9321C11.0894 26.6009 10.6246 25.6225 11.1569 24.9693ZM16.1822 41.1551L21.5988 28.5307L26.79 33.7218L18.94 42.8697C15.0812 47.3665 13.8486 46.5938 16.1822 41.1551ZM36.0894 22.885L30.9549 28.8684L24.3065 22.22L24.7069 21.2868H35.3548C36.5179 21.2868 36.8303 22.0216 36.0894 22.885ZM41.6848 45.6105L4.09672 8.02244C3.68485 7.61056 3.69956 6.92806 4.10248 6.52514C4.51754 6.11008 5.19186 6.11145 5.59979 6.51938L43.1879 44.1075C43.5998 44.5194 43.5851 45.2019 43.1821 45.6048C42.7671 46.0199 42.0928 46.0185 41.6848 45.6105Z"
    />
  </svg>
)
